<template>
	<transition name="modal-fade">
		<section class="modal-backdrop">
			<section class="loading-box">
				<section class="lds-spinner">
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
					<section></section>
				</section>
				<section>{{ text }}</section>
			</section>
		</section>
	</transition>
</template>

<script>
	export default {
		props: {
			text: {
				required: false,
				type: String,
				default: "Please wait...",
			},
		},
	};
</script>

<style scoped>
.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
}
.modal-backdrop {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.3);
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.5s ease;
}

.loading-box {
	position: fixed;
	top: 50%;
	width: 25%;
	margin: auto;
	z-index: 999;
	left: 0px;
	right: 0px;
	text-align: center;
	padding: 10px;
}
.lds-spinner {
	color: official;
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}
.lds-spinner section {
	transform-origin: 40px 40px;
	animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner section:after {
	content: " ";
	display: block;
	position: absolute;
	top: 3px;
	left: 37px;
	width: 6px;
	height: 18px;
	border-radius: 20%;
	background: rgb(52, 74, 197);
}
.lds-spinner section:nth-child(1) {
	transform: rotate(0deg);
	animation-delay: -1.1s;
}
.lds-spinner section:nth-child(2) {
	transform: rotate(30deg);
	animation-delay: -1s;
}
.lds-spinner section:nth-child(3) {
	transform: rotate(60deg);
	animation-delay: -0.9s;
}
.lds-spinner section:nth-child(4) {
	transform: rotate(90deg);
	animation-delay: -0.8s;
}
.lds-spinner section:nth-child(5) {
	transform: rotate(120deg);
	animation-delay: -0.7s;
}
.lds-spinner section:nth-child(6) {
	transform: rotate(150deg);
	animation-delay: -0.6s;
}
.lds-spinner section:nth-child(7) {
	transform: rotate(180deg);
	animation-delay: -0.5s;
}
.lds-spinner section:nth-child(8) {
	transform: rotate(210deg);
	animation-delay: -0.4s;
}
.lds-spinner section:nth-child(9) {
	transform: rotate(240deg);
	animation-delay: -0.3s;
}
.lds-spinner section:nth-child(10) {
	transform: rotate(270deg);
	animation-delay: -0.2s;
}
.lds-spinner section:nth-child(11) {
	transform: rotate(300deg);
	animation-delay: -0.1s;
}
.lds-spinner section:nth-child(12) {
	transform: rotate(330deg);
	animation-delay: 0s;
}
@keyframes lds-spinner {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>